/**
 * @description : Button
 * @author : vineela
 * @date : 26-09-2025
 * */
import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';

function ButtonCustom(props) {
  const { state } = props || {};
  const [size] = useState(props.size);
  const [className] = useState(props.className);
  const [variant] = useState(props.variant);
  const [isDisabled] = useState(props.isDisabled);

  return (
    <Button
      className={`btn-${variant} btn-${size} ${className}`}
      style={props.style}
      onClick={props.onClick}
      disabled={isDisabled}
    >
      {props.loading === true ? (
        <Spinner animation="border" variant="light" />
      ) : (
        props.text
      )}
    </Button>
  );
}
Button.defaultProps = {
  size: '',
  variant: '',
  onClick: () => {},
  loading: false,
};
export default ButtonCustom;
